import qs from 'qs'
/**
 * 获取url中的参数
 * @param  {String} name 参数名
 * @param  {String} str  query串
 * @return {string}      [description]
 */
export const getQueryString = (name, str) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$|#)", "i");
  var r = str.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export const getQueryValue = (url, key) => {
  let result = '';
  let query = url;
  let queryList = query.split('?'); // 有多个query的情况
  for (var i = 0, len = queryList.length; i < len; i++) {
    result = getQueryString(key, queryList[i]);
    if (result) {
      return result;
    }
  }
  return result;
}

export const parseObj2Str = obj => {
  var arr = [];
  let url
  if(obj.url){
    url = obj.url
  }
  delete obj.url
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      arr.push(key + '=' + (obj[key] || ''));
    }
  }
  if(url){
    arr.push(`url=${url}`)
  }
  obj.url = url
  return arr.join('&');
}

/**
 * 打开链接
 * @param  {String} link 要打开的链接地址
 */
export const open = (link) => {
  if (getUA().isAndroid && getUA().isChrome) {
    location.href = link;
    return;
  }
  openByIframe(link);
}
/**
 * 通过iframe触发地址
 * @param  {String} link 打开地址
 */
export const openByIframe = link => {
  let iframe = document.getElementById('open_app_iframe');
  if (!iframe) {
    iframe = document.createElement("iframe");
    iframe.setAttribute("id", "open_app_iframe");
    iframe.setAttribute("width", "0px");
    iframe.setAttribute("height", "0px");
    iframe.style.display = 'none';

    let body = document.getElementsByTagName('body')[0];
    document.body.appendChild(iframe);
  }
  iframe.setAttribute("src", link);
}

export const parseUrl = url => qs.parse(url, { ignoreQueryPrefix: true })

